export default __webpack_public_path__ + "static/media/CL06.1.9d394cbf.mp3";